import { render, staticRenderFns } from "./Mentionable.vue?vue&type=template&id=740b896a&"
import script from "./Mentionable.vue?vue&type=script&lang=js&"
export * from "./Mentionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740b896a')) {
      api.createRecord('740b896a', component.options)
    } else {
      api.reload('740b896a', component.options)
    }
    module.hot.accept("./Mentionable.vue?vue&type=template&id=740b896a&", function () {
      api.rerender('740b896a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/forms/Mentionable.vue"
export default component.exports